import * as types from '../actionTypes';

// Estado da feature de Cotação (Fase 1).
// quotes        -> lista de cotações já no escopo de permissão do usuário
// selectedQuote -> cotação aberta no detalhe (/cotacao/:id)
// activeQuoteId -> cotação "ativa" para adição rápida (persistida no mock)
// loading       -> flag de carregamento
const initialState = {
	quotes: [],
	selectedQuote: null,
	activeQuoteId: null,
	detailOpen: false,
	loading: false
};

export const quoteReducer = (state = initialState, action) => {

	switch (action.type) {
		case types.SET_QUOTES:
			return { ...state, quotes: action.payload };
		case types.SET_SELECTED_QUOTE:
			return { ...state, selectedQuote: action.payload };
		case types.SET_ACTIVE_QUOTE:
			return { ...state, activeQuoteId: action.payload };
		case types.SET_QUOTE_DETAIL_OPEN:
			return { ...state, detailOpen: action.payload };
		case types.SET_QUOTE_LOADING:
			return { ...state, loading: action.payload };
		default:
			return state;
	}

};
